var map = {
	"./en/404.json": 5882,
	"./en/about.json": 1420,
	"./en/blog.json": 3028,
	"./en/contact.json": 7765,
	"./en/footer.json": 9922,
	"./en/header.json": 4995,
	"./en/seo.json": 9406,
	"./en/translation.json": 4779,
	"./pt/404.json": 9023,
	"./pt/about.json": 6637,
	"./pt/blog.json": 1910,
	"./pt/contact.json": 7486,
	"./pt/footer.json": 9400,
	"./pt/header.json": 6322,
	"./pt/seo.json": 3705,
	"./pt/translation.json": 4034
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6376;